export * from './UploadMedicalDocument';
